// @ts-nocheck
import { call, put, takeLatest } from 'redux-saga/effects';
import router from 'components/Router';
import { errorToast } from 'utils/toastHandler';
import {
  // getSystemFields,
  // checkUnidentifiedCostCodes,
  saveBulkResourceAssigner,
  saveResourceAssigner,
} from '../services/resource_assigner';
import resourceAssignerImportActions, {
  Types,
} from '../actions/resource_assigner_bulk_import';

// function* getSystemFieldsRequest(action) {
//   try {
//     const { params } = action;
//     const response = yield call(getSystemFields, params);
//     yield put(
//       resourceAssignerImportActions.getSystemFieldsSuccess(response.data),
//     );
//   } catch (error) {
//     yield put(resourceAssignerImportActions.getSystemFieldsFailure());
//   }
// }

// function* checkUnidentifiedCostCodesRequest(action) {
//   try {
//     const { payload } = action;
//     const response = yield call(checkUnidentifiedCostCodes, payload);
//     yield put(
//       resourceAssignerImportActions.checkUnidentifiedCostCodesSuccess({
//         data: response.data,
//       }),
//     );

//     yield put(resourceAssignerImportActions.setStep({ step: 3 }));
//   } catch (error) {
//     yield put(
//       resourceAssignerImportActions.checkUnidentifiedCostCodesFailure(),
//     );
//   }
// }

function* saveBulkResourceAssignersRequest(action) {
  try {
    const { params, payload } = action;
    yield call(saveBulkResourceAssigner, params, payload);
    yield put(resourceAssignerImportActions.saveBulkResourceAssignerSuccess());
    if (params.templateId === 90) {
      router.navigate(`/resource_assigner/`);
    } else {
      router.navigate(`/settings/resource-code/${params.templateId}`);
    }
  } catch (error) {
    yield put(resourceAssignerImportActions.saveBulkResourceAssignerFailure());
    error && errorToast(error.response.data.error);
  }
}

function* saveResourceAssignersRequest(action) {
  try {
    const { params, payload } = action;
    yield call(saveResourceAssigner, params, payload);
    yield put(resourceAssignerImportActions.saveResourceAssignerSuccess());
    if (params.templateId === 90) {
      router.navigate(`/resource_assigner/`);
    } else {
      router.navigate(`/settings/resource-code/${params.templateId}`);
    }
  } catch (error) {
    yield put(resourceAssignerImportActions.saveResourceAssignerFailure());
    error && errorToast(error.response.data.error);
  }
}

// function* checkDefaultCostCodeRequest() {
//   try {
//     const response = yield call(checkDefaultCostCode);
//     yield put(
//       resourceAssignerImportActions.checkDefaultCostCodeSuccess(response.data),
//     );
//   } catch (error) {
//     yield put(resourceAssignerImportActions.checkDefaultCostCodeFailure());
//     error && errorToast(error.response.data.error);
//   }
// }

function* resourceAssignerWatcher() {
  // yield takeLatest(Types.GET_SYSTEM_FIELDS_REQUEST, getSystemFieldsRequest);
  // // yield takeLatest(
  // //   Types.CHECK_UNIDENTIFIED_COST_CODES_REQUEST,
  // //   checkUnidentifiedCostCodesRequest,
  // // );
  yield takeLatest(
    Types.SAVE_BULK_RESOURCE_ASSIGNER_REQUEST,
    saveBulkResourceAssignersRequest,
  );

  yield takeLatest(
    Types.SAVE_RESOURCE_ASSIGNER_REQUEST,
    saveResourceAssignersRequest,
  );
  // yield takeLatest(
  //   Types.CHECK_DEFAULT_COST_CODE_REQUEST,
  //   checkDefaultCostCodeRequest,
  // );
}

export default resourceAssignerWatcher;
